import "plyr/dist/plyr.css";

export default defineNuxtPlugin(() => {
  console.log("🟢 Plyr plugin loaded");
});
